import apiRequest from './apiRequest';

const taskApi = {
    createTask(accountId, taskData, token) {
        return apiRequest(`/api/tasks/account/${accountId}`, 'POST', token, taskData);
    },

    updateTask(taskId, taskData, token) {
        return apiRequest(`/api/tasks/${taskId}`, 'PUT', token, taskData);
    },

    deleteTask(taskId, token) {
        return apiRequest(`/api/tasks/${taskId}`, 'DELETE', token);
    },

    getAllTasks(token) {
        return apiRequest('/api/tasks', 'GET', token);
    },

    getTasksByAccount(accountId, token) {
        return apiRequest(`/api/tasks/account/${accountId}`, 'GET', token);
    },

    addComment(taskId, commentData, token) {
        return apiRequest(`/api/tasks/${taskId}/comments`, 'POST', token, commentData);
    },

    updateComment(taskId, commentId, commentData, token) {
        return apiRequest(`/api/tasks/${taskId}/comments/${commentId}`, 'PUT', token, commentData);
    },

    deleteComment(taskId, commentId, token) {
        return apiRequest(`/api/tasks/${taskId}/comments/${commentId}`, 'DELETE', token);
    },


    addAttachment(taskId, attachmentData, token) {
        return apiRequest(`/api/tasks/${taskId}/attachments`, 'POST', token, attachmentData);
    },

    deleteAttachment(taskAttachmentId, token) {
        return apiRequest(`/api/tasks/attachments/${taskAttachmentId}`, 'DELETE', token);
    },
    getAttachments(taskAttachmentId, token) {
        return apiRequest(`/api/tasks/${taskAttachmentId}/attachments`, 'GET', token);
    },

     searchTask(searchTerm, token) {
        return apiRequest(`/api/tasks/search/${searchTerm}`, 'GET', token);
    }
};

export default taskApi;
